export enum ResponseCode {
  STATUS_301 = '¡El recurso ha sido movido permanentemente a una nueva ubicación!',
  STATUS_302 = '¡El recurso se ha encontrado temporalmente en una nueva ubicación!',
  STATUS_400 = 'Lo sentimos, no pudimos entender tu solicitud. Por favor, verifica los datos ingresados e inténtalo nuevamente.',
  STATUS_401 = 'Lo sentimos, no estás autorizado para acceder a este recurso. Por favor, inicia sesión primero.',
  STATUS_404 = '¡Lo sentimos! La página que estás buscando no se pudo encontrar.',
  STATUS_500 = '¡Vaya! Parece que hay un problema en nuestro servidor. Por favor, inténtalo nuevamente más tarde.',
  STATUS_503 = 'Lo sentimos, el servicio no está disponible en este momento. Por favor, intenta nuevamente más tarde.',
}
